export const canUserManagePermissions = (inventory, userId) => {
  return userId === String(inventory.ownerId) || inventory.adminsIds.includes(userId);
};